/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {
	Component,
	Inject,
	OnInit,
	EventEmitter,
	Input,
	AfterContentChecked,
} from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from "@angular/material/dialog";
import { SessionService } from "../../../platform/base/services/session.service";
import { Overlay } from "@angular/cdk/overlay";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BreakpointObserver } from "@angular/cdk/layout";
import { ActivatedRoute } from "@angular/router";

import { IErrorObject } from "../../../../../types/platform/universe";

import { ResponsiveWithUpdatableComponent } from "../../base/components/responsivewithupdatable.component";
import { Errors } from "../../base/library/errors";
import { MessageDialogComponent } from "../../base/components/message-dialog/message-dialog.component";
import { TranslateService } from "@ngx-translate/core";

import _ from "lodash";
import moment from "moment";

import { ShotdataService } from "../shotdata.service";
import { ShotScoreService } from "../../shot/shot-score.service";

/*
 *
 * */
@Component({
	selector: "aigia-confirm-create-shotavg-dialog-root",
	templateUrl: "./confirm-create-shotavg-dialog.component.html",
	styleUrls: ["./confirm-create-shotavg-dialog.component.css"],
})
export class ConfirmCreateShotAvgDialogComponent
	extends ResponsiveWithUpdatableComponent
	implements OnInit
{
	public device: string;
	public params: any = {};

	public _ = _;
	public showConfirmDialog = false;
	public shot: any = null;
	public parts: any = null;
	public formData = {
		name: "",
		memo: "",
	};
	public updateShot = new EventEmitter<any>();
	public inputChange = new EventEmitter<any>();
	// public adviceCodePos = "-100px";

	@Input() public user: any;

	constructor(
		public matDialog: MatDialog,
		protected session: SessionService,
		protected overlay: Overlay,
		protected snackbar: MatSnackBar,
		protected breakpointObserver: BreakpointObserver,
		protected route: ActivatedRoute,
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<ConfirmCreateShotAvgDialogComponent>,
		public translate: TranslateService,
		private shotsService: ShotdataService,
		public shotscore: ShotScoreService
	) {
		super(session, breakpointObserver, matDialog, translate);
	}

	/**
	 * @returns none
	 */
	ngOnInit(): void {
		this.getSession((error: IErrorObject, session: object): void => {
			super.ngOnInit();

			this.user = this.data.user;
			this.shot = this.data.shot;
			this.parts = this.data.parts;
			this.formData.name = _.get(this.shot, "name");
			this.formData.memo = "";

			this.device = "desktop";

			this.isHandsetPortrait.subscribe((layoutDetector: any) => {
				if (layoutDetector.matches) {
					this.device = "handset";
				}
			});

			this.isTabletPortrait.subscribe((layoutDetector: any) => {
				if (layoutDetector.matches) {
					this.device = "tablet";
				}
			});

			this.isWeb.subscribe((layoutDetector: any) => {
				if (layoutDetector.matches) {
					this.device = "desktop";
				}
			});
		});
	}

	/**
	 *
	 */
	public cancel(): void {
		this.matDialogRef.close(null);
	}

	protected errorDialog(
		error: IErrorObject,
		callback: (result: any) => void = (error: IErrorObject) => {}
	): void {
		if (error) {
			const dialog: MatDialogRef<any> = this.matDialog.open(
				MessageDialogComponent,
				{
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {
						content: {
							title: "Error.",
							message: error.message,
							tag: error.tag,
						},
					},
					disableClose: true,
				}
			);

			dialog.afterClosed().subscribe((result: any): void => {
				callback(result);
			});
		}
	}

	public confirmToModel(data: any): any {
		return data;
	}

	public toListView(object: any): any {
		return object;
	}

	public toView(data: any): any {
		return data;
	}

	public handleInputChange = ($event, field) => {
		console.log("handleInputChange", $event, field);
		switch (field) {
			case "name":
				let dateValue = moment(
					$event.target.value.substr(0, 10),
					"YYYY-MM-DD"
				);
				let isValid = dateValue.isValid();
				if (!isValid) {
					$event.target.value = moment().format("YYYY-MM-DD");
				} else {
					$event.target.value = dateValue.format("YYYY-MM-DD");
				}

				this.formData.name = $event.target.value;
				break;

			default:
				break;
		}
	};

	public onCreateAVGShot = () => {
		this.shot.name = this.formData.name;
		this.shot.memo = this.formData.memo || "";
		this.updateShot.emit({
			type: "create-avgshot",
			data: this.shot,
		});
	};

	public getClubName = () => {
		let clubType = _.get(this.shot, "platform.description.club");
		let clubName =
			_.get(
				this.shotscore.clubs.find((x) => x.value === clubType),
				"name"
			) || "";

		return clubName;
	};
}
